import isEmpty from "lodash/isEmpty";

export const specialCharErrorMsg = "Sorry, only these special characters are allowed: & ' - /";
export const emailErrorMsg = "Please enter a valid email address";
export const specialCharRegex = /[^a-zA-Z0-9\s&'\-/]/;
export const otherCategoryDescriptionRegex = /^[A-Za-z0-9 &'/\-]+$/;

export const emailRegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const specialCharValidationRule = (value) => {
  return !specialCharRegex.test(value) || specialCharErrorMsg;
}

export const isValidEmail = (value) => {
  return isEmpty(value) || emailRegExp.test(value) || emailErrorMsg;
}
// Matches 6–12 digit HS codes, with or without dots
const hsCodeRegex = /^(?:\d{2}(?:\.\d{2}){2,5}|\d{6,12})$/;


export function isValidHSTariff(code) {
  return hsCodeRegex.test(code);
}
